import { isDevEnvironment } from './env';

/* In here we store the Google Optimize global variables which are the parameters
   for the A/B testing
*/

// the window variable is to be defined.

export const TESTS_DICTIONARY = {
  optimizelySuiteCardB: 'optimizelySuiteCardB',
  optimizelySuiteFilterIcons: 'optimizelySuiteFilterIcons',
  optimizelyPoconosTowerOption: 'optimizelyPoconosTowerOption',
  // COMMENTED BY HOTFIX 51917 UNTIL APRIL 1 2024
  // optimizelyBundleDealModalB: 'optimizelyBundleDealModalB',
  // optimizelyBundleDealModalC: 'optimizelyBundleDealModalC',
  optimizelyWaterParkPassesWarning: 'optimizelyWaterParkPassesWarning',
  optimizelyTwoImagesSuiteCard: 'optimizelyTwoImagesSuiteCard',
  optimizelyNewFilters: 'optimizelyNewFilters',
  optimizelyPaymentWarnings: 'optimizelyPaymentWarnings',
  optimizelySuperscriptStaySummarySuite: 'optimizelySuperscriptStaySummarySuite',
  optimizelyPromoClarity: 'optimizelyPromoClarity',
  optimizelyTruncateCentsVillas: 'optimizelyTruncateCentsVillas',
  optimizelyHierarchyFlip: 'optimizelyHierarchyFlip',
  optimizelyResortFeeInSuiteCard: 'optimizelyResortFeeInSuiteCard',
  optimizelyNewCardNonPoconos: 'optimizelyNewCardNonPoconos',
  optimizelySecureCheckout: 'optimizelySecureCheckout',
  optimizelyAppleGoolePayOrder: 'optimizelyAppleGoolePayOrder',
  optimizelyDisplayResortFeeWithTotalInSuiteCardH: 'optimizelyDisplayResortFeeWithTotalInSuiteCardH',
  optimizelyDisplayResortFeeWithTotalInSuiteCardJ: 'optimizelyDisplayResortFeeWithTotalInSuiteCardJ',
  optimizelyExpressCheckout: 'optimizelyExpressCheckout',
  optimizelyI4Iframe: 'optimizelyI4Iframe',
  optimizelyReturnZSRecommendation: 'optimizelyReturnZSRecommendation',
  optimizelyDiningPageRedesign: 'optimizelyDiningPageRedesign',
  optimizelyFamilyRates: 'optimizelyFamilyRates'
};

/**
 * This is for tests that are located on multiple pages or components.
 * This array is to be empty by default.
 */
const MULTIPLE_TESTS_ACTIVE_LISTS = [];

/**
 *
 * @param {*} testName This is the name of the global variable that is set in Optimizely
 * @param {*} developMode This is a boolean that is set to true if you want to see the test in develop mode
 * @returns
 */
export const getTestValueAB = (testName, developMode = false) => {
  if (developMode) {
    return true;
  }
  if (isDevEnvironment && MULTIPLE_TESTS_ACTIVE_LISTS.includes(testName)) {
    return true;
  }

  return window[testName] || false;
};
